import angular from 'angular';

import BenjiUserFactory from './benjiUserFactory';
import CommonDataFactory from './commonDataFactory';
import CommonValidationFactory from './commonValidationFactory';
import TempDocumentFactory from './tempDocumentFactory';
import UIDisplayFactory from './uiDisplayFactory';

export default angular.module('app.common.dataFactories', [])
    .service('CommonDataFactory', CommonDataFactory)
    .service('CommonValidationFactory', CommonValidationFactory)
    .factory('TempDocumentFactory', TempDocumentFactory)
    .factory('BenjiUserFactory', BenjiUserFactory)
    .service('UiDisplayFactory', UIDisplayFactory)
    .name;



// WEBPACK FOOTER //
// ./src/app/common/dataFactories/index.js